import { ComponentFactoryResolver } from '@angular/core';
import { Observer } from 'rxjs';
import { ModalConfigurationModel } from './modal-configuration.model';

export enum ModalExit {
	ACCEPT = 'accept',
	CLOSE = 'close',
}

export enum ModalConfirmAction {
	CONFIRM = 'confirm',
	CANCEL = 'cancel',
}

/**
 * Event Type for Dialog Status
 */
export enum ModalEventType {
	OPEN = 'modal-event-type-open',
	CLOSE = 'modal-event-type-close',
}

export class ModalModel {
	componentFactoryResolver: ComponentFactoryResolver;
	component: any;
	data: any;
	content?: any;
	public modalConfiguration?: ModalConfigurationModel;
	observable?: Observer<any>;
}
